import React from 'react'
import { useTranslation } from 'react-i18next'
import { getSections } from './constants'

export type FilterSectionKey =
  | 'popular'
  | 'experience'
  | 'facility'
  | 'accommodation'
  | 'budget'
  | 'life'
  | 'privilege'
  | 'transport'
  | 'child'
  | 'area'
  | 'text_search'

interface DetailFilterBarProps {
  onOpenModal: (sectionKey: FilterSectionKey) => void
}

export const DetailFilterBar: React.FC<DetailFilterBarProps> = ({ onOpenModal }) => {
  const { t } = useTranslation()
  const sections = React.useMemo(() => getSections(t), [t])

  return (
    <div
      className="w-full flex items-center gap-2"
      style={{ maxWidth: 420, margin: '0 auto' }} // SearchBarと同じ幅に調整
    >
      {sections
        .filter((section) => section.id !== 'popular')
        .map((section) => (
          <button
            key={section.id}
            className="border px-4 py-2 bg-white text-black text-sm flex items-center min-w-[90px] shrink-0 hover:bg-gray-100 transition"
            style={{ borderColor: '#d1d5db', borderRadius: 8 }}
            onClick={() => onOpenModal(section.id as FilterSectionKey)}
            type="button"
          >
            {section.label}
            <img
              src="/images/icon/arrow_down.svg"
              alt="開く"
              width={24}
              height={24}
              style={{ marginLeft: 4, marginTop: -8, marginBottom: -8, maxWidth: 'none' }}
            />
          </button>
        ))}
    </div>
  )
}
